import { render, staticRenderFns } from "./RelatedQuestionsBar.vue?vue&type=template&id=5baa22d2&scoped=true"
import script from "./RelatedQuestionsBar.vue?vue&type=script&lang=ts"
export * from "./RelatedQuestionsBar.vue?vue&type=script&lang=ts"
import style0 from "./RelatedQuestionsBar.vue?vue&type=style&index=0&id=5baa22d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baa22d2",
  null
  
)

export default component.exports